// basics
import Vue from "vue";
import EventBus from "@/EventBus";

Vue.prototype.$eventBus = EventBus;
Vue.prototype.GAEvent = (
  event,
  param1Name = false,
  param1Value = false,
  param2Name = false,
  param2Value = false,
  param3Name = false,
  param3Value = false
) => {
  let newEvent = {
    event: event
  };
  if (param1Name && param1Value) {
    newEvent["param_1_name"] = param1Name;
    newEvent["param_1_value"] = param1Value;
  }
  if (param2Name && param2Value) {
    newEvent["param_2_name"] = param2Name;
    newEvent["param_2_value"] = param2Value;
  }
  if (param3Name && param3Value) {
    newEvent["param_3_name"] = param3Name;
    newEvent["param_3_value"] = param3Value;
  }
  window.dataLayer.push(newEvent);
};
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import { Drop } from "vue-drag-drop";

Vue.component("drop", Drop);

Vue.config.productionTip = true;
//styles
import "./assets/scss/fonts.scss";
import "./assets/scss/keen-ui.scss";
import "./assets/scss/global.scss";

//keen ui
import KeenUI from "keen-ui";

Vue.use(KeenUI);
//axios
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = `${process.env.VUE_APP_API_ROOT}/api/`;
Vue.axios.defaults.headers = {
  "Content-Type": "multipart/form-data"
};
Vue.axios.defaults.withCredentials = true;
// my global components
import navbar from "@/components/Navbar";

Vue.component("nav-bar", navbar);
import svgIcon from "@/components/svgIcon";

Vue.component("svg-icon", svgIcon);
//app init
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
